import PropTypes from "prop-types";
import Button from "@shared/v2/Button";
import { ArrowLeftSolidV6, ArrowRightSolidV6, ForwardSolidV6, UserSolidV6 } from "@shared/v2/Icomoon";
import { DncFlag } from "@shared/Sms";
import TwoPartyFlag from "@shared/Sms/TwoPartyFlag";
import TextLink from "@shared/v2/TextLink";
import Tooltip from "@shared/v2/Tooltip";
import { useFeatureFlags } from "../../../reducers/layoutReducer/selectors";
import PhoneStatusIcon from "../PhoneStatusIcon";

const UpNext = ({
  className = "",
  name = "",
  phoneNumber = "",
  dnc = false,
  twoParty = false,
  pdpLink = "",
  onBack = null,
  onSkip = null,
  callIcon = null,
  tooltip = null,
  isDataFetched = false,
}) => {
  const featureFlags = useFeatureFlags();

  const skipButton = (
    <Button
      schema="tertiary"
      className="tw-inline-flex tw-items-center tw-gap-[4px]"
      disabled={!onSkip}
      onClick={onSkip}
    >
      Skip
      <ForwardSolidV6 size="s" />
    </Button>
  );

  return (
    <div
      className={`tw-border-1px tw-border-solid tw-rounded tw-border-gray-10 tw-w-full tw-p-8px tw-flex tw-justify-between tw-text-gray-75 ${className}`}
    >
      <div className="tw-flex tw-items-center tw-gap-8px">
        <ArrowRightSolidV6 size="m" />
        <span>Up Next:</span>
        <TextLink href={pdpLink} target="_blank">
          <div className="tw-text-14d tw-font-semibold tw-max-w-[214px] tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis">
            {name}
          </div>
        </TextLink>
        <div className="tw-font-semibold tw-text-gray-50">Mobile: {phoneNumber}</div>
        <DncFlag show={dnc} />
        <TwoPartyFlag show={twoParty} />
        {isDataFetched && <PhoneStatusIcon callIcon={callIcon} tooltip={tooltip} />}
      </div>
      <div className="tw-flex tw-gap-[8px]">
        {!featureFlags.dialerSkipACall && (
          <Button
            schema="tertiary"
            className="tw-inline-flex tw-items-center tw-gap-[4px]"
            onClick={() => window.open(pdpLink, "_blank")}
          >
            Preview
            <UserSolidV6 size="s" />
          </Button>
        )}
        {featureFlags.dialerSkipACall && (
          <>
            {onBack && (
              <Button
                schema="tertiary"
                className="tw-inline-flex tw-items-center tw-gap-[4px]"
                onClick={onBack}
              >
                <ArrowLeftSolidV6 size="s" />
                Back
              </Button>
            )}
            {onSkip ? (
              skipButton
            ) : (
              <Tooltip
                trigger={skipButton}
                placement="top"
                innerClassName="tw-max-w-[200px]"
                content="No more contacts in this list. Save and continue to end dialer session."
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

UpNext.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  phoneNumber: PropTypes.string,
  dnc: PropTypes.bool,
  twoParty: PropTypes.bool,
  pdpLink: PropTypes.string,
  onBack: PropTypes.func,
  onSkip: PropTypes.func,
  callIcon: PropTypes.func,
  tooltip: PropTypes.string,
  isDataFetched: PropTypes.bool,
};

export default UpNext;
